import { jsx as r } from "react/jsx-runtime";
import { useTheme as a } from "styled-components";
import p from "../../icons/info.js";
import c from "../IconButton/IconButton.js";
import s from "../Tooltip/Tooltip.js";
const f = ({ className: t, children: e, title: i = void 0, Icon: m, IconButtonProps: l, ...n }) => {
  const o = a();
  return /* @__PURE__ */ r(s, {
    title: i || e,
    placement: "right",
    ...n,
    children: /* @__PURE__ */ r(c, {
      flavor: o.isLightTheme ? o.colors.grey500 : o.colors.darkGrey300,
      size: "extraSmall",
      variant: "normal",
      className: t,
      ...l,
      children: m ?? /* @__PURE__ */ r(p, {})
    })
  });
};
f.displayName = "TooltipInfo";
export {
  f as default
};
